import React from "react";
import { Reveal, Eyebrow } from "../ui";

import screenThandiwe from "../../assets/images/screen_thandiwe.png";
import screenDiscover from "../../assets/images/screen_discover.png";
import screenFilters from "../../assets/images/screen_filters.png";
import screenMessages from "../../assets/images/screen_messages.jpg";
import screenChat from "../../assets/images/screen_chat.jpg";
import screenMatches from "../../assets/images/screen_matches.jpg";
import screenProfile from "../../assets/images/screen_profile.jpg";
import screenSubscribe from "../../assets/images/screen_subscribe.jpg";

const galleryScreens = [
  { src: screenThandiwe, label: "Discover" },
  { src: screenDiscover, label: "Profile card" },
  { src: screenFilters, label: "Filters" },
  { src: screenMessages, label: "Messages" },
  { src: screenChat, label: "Chat" },
  { src: screenMatches, label: "Connections" },
  { src: screenProfile, label: "My Profile" },
  { src: screenSubscribe, label: "Subscribe" },
];

export default function Gallery() {
  return (
    <section className="bg-blush py-16 lg:py-24 px-[5%]" id="gallery">
      <div className="w-full">
        <Reveal>
          <Eyebrow>Every screen</Eyebrow>
        </Reveal>

        <Reveal delay={100}>
          <h2 className="text-[clamp(28px,4vw,44px)] font-bold tracking-[-1.2px] mb-3">
            See the full experience
          </h2>
        </Reveal>

        <Reveal delay={200}>
          <p className="text-base text-muted max-w-[500px] leading-relaxed mb-8 lg:mb-12">
            From setting up your profile to finding your connection — every
            screen is designed to feel effortless.
          </p>
        </Reveal>

        {/* Horizontal gallery */}
        <div
          className="w-full overflow-x-auto overflow-y-hidden scrollbar-hide touch-pan-x pb-2"
          style={{
            WebkitOverflowScrolling: "touch",
          }}
        >
          <div className="flex flex-row gap-5 w-max">
            {galleryScreens.map((s, i) => (
              <div key={i} className="flex flex-col items-center flex-shrink-0">
                <div className="w-[145px] h-[300px] sm:w-[180px] sm:h-[370px] bg-black rounded-[24px] sm:rounded-[30px] p-[7px] sm:p-[9px] shadow-[0_24px_48px_rgba(0,0,0,0.12)] overflow-hidden hover:-translate-y-2.5 hover:scale-[1.03] hover:shadow-[0_32px_64px_rgba(0,0,0,0.2)] transition-all duration-300">
                  <img
                    src={s.src}
                    alt={s.label}
                    className="w-full h-full object-cover rounded-[17px] sm:rounded-[22px] block"
                    draggable={false}
                  />
                </div>

                <p className="text-[13px] font-medium text-muted text-center mt-3">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
